import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ApiCallingService } from '../../services/api-calling.service';
import { ConfigApi } from '../../config-api';

@Component({
  selector: 'app-term-conditions',
  templateUrl: './term-conditions.component.html',
  styleUrls: ['./term-conditions.component.css']
})
export class TermConditionsComponent implements OnInit {
  terms:any;
  
  constructor(     
     private http: HttpClient,
     private toastr: ToastrService,
     private apiCallingService: ApiCallingService
  ) { }

  ngOnInit(): void {
    this.getTerms();
  }
  getTerms() { 
    this.apiCallingService.callAPI({}, 'GET', ConfigApi.URLS.MY_PROFILE.TERM_AND_CONDITIONS)
      .subscribe(res => {
         console.log('sss',res);
          this.terms = res;
      });
  }
  

}
